export const getCurrentUserEmail = () => {
  try {
    const email = sessionStorage.getItem('logInUserEmail');
    if (email) {
      try {
        return JSON.parse(email);
      } catch {
        return email;
      }
    }
    const localEmail = localStorage.getItem('logInUserEmail') || localStorage.getItem('userEmail');
    if (localEmail) {
      try {
        return JSON.parse(localEmail);
      } catch {
        return localEmail;
      }
    }
    const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      return user?.email || user?.userEmail;
    }
    return null;
  } catch (error) {
    console.error('Error getting user email from storage:', error);
    return null;
  }
};
